import { WRITABLE_ABSENCE_TYPES, WritableAbsenceType } from '@app/shared/services/dtos/reports/writable-absence-type';
import { ABSENCE_TYPE_TRANSLATION_KEYS, AbsenceType } from '@app/shared/types/enums/absence-type';
import { DropdownItem } from '@app/shared/types/models/shared/dropdown-item';

export const WRITABLE_ABSENCE_TYPE_OPTIONS: DropdownItem<WritableAbsenceType>[] = WRITABLE_ABSENCE_TYPES.map(type => ({
  value: type,
  label: ABSENCE_TYPE_TRANSLATION_KEYS[type]
}));

export function absenceTypeTranslationKey(type: AbsenceType | undefined): string | undefined {
  return type ? ABSENCE_TYPE_TRANSLATION_KEYS[type] : undefined;
}
